import React, { FunctionComponent } from "react";

const SignBadgeCircleIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/maps-navigation/sign-shapes/sign-badge-circle
  return (
    <svg viewBox="-0.75 -0.75 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.703125 11.25a10.546875 10.546875 0 1 0 21.09375 0 10.546875 10.546875 0 1 0 -21.09375 0Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default SignBadgeCircleIcon;
